if (!customElements.get('sticky-add-to-cart')) {
  customElements.define('sticky-add-to-cart', class StickyAddToCart extends HTMLElement {
    connectedCallback() {
      this.mainButton = document.getElementById(this.dataset.submitButton);
      this.button = this.querySelector('.sticky-atc__button');
      if (!this.mainButton || !this.button) return;

      this.button.addEventListener('click', () => this.mainButton.click());
      this.observer = new IntersectionObserver(([entry]) => {
        this.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        this.setAttribute('aria-hidden', String(!this.classList.contains('is-visible')));
      });
      this.observer.observe(this.mainButton);

      this.buttonObserver = new MutationObserver(() => this.syncButton());
      this.buttonObserver.observe(this.mainButton, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'], childList: true, subtree: true });
      this.syncButton();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.buttonObserver?.disconnect();
    }

    syncButton() {
      const disabled = this.mainButton.disabled || this.mainButton.getAttribute('aria-disabled') === 'true';
      this.button.disabled = disabled;
      this.button.querySelector('span').textContent = this.mainButton.querySelector('span')?.textContent.trim() || window.variantStrings.addToCart;
    }
  });
}
